import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function TaskCompletionStatus({
  progress,
  endDate,
  isConstrained,
  isDisabled,
  task,
  resource,
}: Props) {
  const now = new Date();

  const isLate =
    !!endDate &&
    new Date(endDate) <
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const isCompleted = progress === 100;

  const userAllocation = task?.allocations?.find(
    (alloc) => alloc.resource.uuid === resource?.uuid,
  );
  const hasFullAllocation = userAllocation?.percentComplete === 100;

  const showBlackCheckmark = hasFullAllocation && !isCompleted;

  return (
    <div
      className={classNames(styles.taskCompletionStatus, {
        [styles.progressed]: progress < 100,
        [styles.late]: isLate,
        [styles.completed]: isCompleted,
        [styles.disabled]: isDisabled,
        [styles.constrained]: isConstrained,
        [styles.userChecking]: showBlackCheckmark,
      })}
    />
  );
}

export { TaskCompletionStatus };
